



















import { Component, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { WebhookAdapterVersion } from "@/data/enums/webhooks";

// Types
import { IWebhookForm } from "@/models/webhooks";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "webkook-add-edit-form": () =>
      import("@/components/app/admin/settings/webhooks/webkookAddEditForm.vue")
  }
})
export default class CreateWebhookModal extends Mixins(HasValidation) {
  // Data

  public form: IWebhookForm = {
    name: "",
    description: "",
    enabled: true,
    url: "",
    version: WebhookAdapterVersion.FIRST
  };

  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    if (!this.canCreateWebhook) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      const { id } = await this.createWebhook();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.successfully_saved")
      });

      this.$router.push({
        name: AdminRoutes.WEBHOOKS_SETTINGS_WEBHOOK_EDIT,
        params: {
          webhookId: id
        }
      });

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createWebhook() {
    return this.$store.dispatch(`data/${DataModules.WEBHOOKS}/create`, {
      data: this.form
    });
  }

  // Computed

  public get canCreateWebhook() {
    return this.$userCan("create_webhook");
  }

  public get formIsDisabled() {
    return !this.canCreateWebhook || this.isProcessing;
  }
}
